<template>
    <v-app class="vuetify-layout">
        <v-navigation-drawer
        width="260"
        app
        clipped
        :mini-variant.sync="mini"
        :mini-variant-width="$vuetify.breakpoint.xs  ? 94 : 86"
        mobile-breakpoint="600"
        hide-overlay
        :touchless="!$vuetify.breakpoint.xs"
        :permanent="!$vuetify.breakpoint.xs"
        >
            <v-list nav>
                <inertia-link href="/manager" @click="openSidebar = false">
                    <v-list-item
                    link :class="{'v-list-item--active' : $page.props.currentRouteName == 'manager.home.index' }"
                    id="dashboard">
                        <v-list-item-icon>
                            <v-icon>mdi-view-dashboard</v-icon><p class="mobile-label">{{"Dashboard"}}</p>
                            </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{"Dashboard"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#dashboard" right open-delay="500">
                            <span>{{"Dashboard"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
                <inertia-link href="/manager/organizations" @click="openSidebar = false">
                    <v-list-item
                    link :class="{'v-list-item--active' : $page.props.currentRouteName.startsWith('manager.organizations')}"
                    id="organizations">
                        <v-list-item-icon><v-icon>mdi-playlist-check</v-icon></v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title>{{"Organizations"}}</v-list-item-title>
                        </v-list-item-content>
                        <v-tooltip activator="#organizations" right  open-delay="500">
                            <span>{{"Organizations"}}</span>
                        </v-tooltip>
                    </v-list-item>
                </inertia-link>
            </v-list>
        </v-navigation-drawer>

        <v-app-bar app class="navbar" clipped-left elevation="1" dark :style="{ backgroundColor : $page.props.organization.themeOptions.primary}">
            <div class="left d-flex align-center">
                <v-btn v-if="$vuetify.breakpoint.xs" elevation="1" fab small @click="openSidebar = !openSidebar">
                    <v-icon>mdi-menu</v-icon>
                </v-btn>
                <logo :logo="null"></logo>
            </div>
            <v-spacer />
            <div class="right">
                <v-menu offset-y origin="top right" transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                        <div class="dropdown-button" elevation="1" v-bind="attrs" v-on="on">
                            <div class="info-wrap" v-show="!$vuetify.breakpoint.xs">
                                <p class="user-full-name">{{ $page.props.user.name}} </p>
                            </div>
                            <v-avatar class="ml-1">
                                <img :src="$page.props.user.profile_photo_url" :alt="$page.props.user.name" class="h-8 w-8 rounded-full object-cover"/>
                            </v-avatar>
                            <v-icon class="arrow">mdi-menu-down</v-icon>
                        </div>
                    </template>
                    <v-list expand nav>
                        <inertia-link href="/user/profile">
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>{{"Profile" }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </inertia-link>
                        <a  @click="logout">
                            <v-list-item link>
                                <v-list-item-content>
                                    <v-list-item-title>{{ "Sign Out"}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </a>
                    </v-list>
                </v-menu>
            </div>
        </v-app-bar>

        <v-main app fluid absolute>
            <div class="slot" fluid>
                <slot name="header" class="page-header"></slot>
                <slot></slot>
            </div>
        </v-main>
    </v-app>
</template>

<script>
import Logo from '@/js/Components/Logo';

export default {
    name: "ManagerLayout",
    components: {
        Logo

    },
    data () {
        return {
            toggleMini: true,
            openSidebar: false
        }
    },
    computed: {
        mini: {
            get() {
                return this.toggleMini;
            },
            set() {
                return this.toggleMini;
            }
        },
        mobile(){
             return this.$vuetify.breakpoint.width < 600
        }
    },
    methods: {
        logout() {
            axios.post('/logout').then(() => {
                window.location = '/';
            })
        },
    },
    mounted() {
        if(sessionStorage.isMini) {
            this.toggleMini = JSON.parse(sessionStorage.isMini);
        }
    },
    beforeDestroy() {
        if (this.toggleMini===true) {
            sessionStorage.setItem('isMini', true);
        } else {
            sessionStorage.setItem('isMini', false);
        }
    }
}
</script>

<style lang="scss">


</style>
